import { parseNumberToLocale } from './numberFormatter';
export var getBalanceWithProductSymbol = function getBalanceWithProductSymbol(productSymbol, productBalance) {
  var applyToUSDOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (productSymbol === 'USD') {
    return '$' + productBalance;
  } else {
    if (applyToUSDOnly) {
      return '' + productBalance;
    } else {
      return productBalance + ' ' + productSymbol;
    }
  }
};
export var getProductFullName = function getProductFullName(product) {
  return product ? product.ProductFullName : '';
};
export var getAvailableProductBalance = function getAvailableProductBalance(product) {
  var negativeIsNaN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return product && product.AvailableBalance ? parseNumberToLocale(product.AvailableBalance, undefined, negativeIsNaN) : '';
};
export var getDailyPercentageChangeClassModifier = function getDailyPercentageChangeClassModifier(change) {
  if (change < 0) {
    return '24h-negative';
  } else if (change > 0) {
    return '24h-positive';
  } else {
    return '';
  }
};